<template>
  <div class="ct-mapbox-legend">
    <span class="ct-mapbox-legend__title" v-text="legendTranslation.title" />
    <div class="ct-mapbox-legend__item" :key="item.key" v-for="item in legendItems">
      <span v-if="item.symbol === 'circle'" class="ct-mapbox-legend__symbol 
        ct-mapbox-legend__symbol--circle" :style="item.style" />
      <span v-else-if="item.symbol === 'diamond'" class="ct-mapbox-legend__symbol ct-mapbox-legend__symbol--diamond"
        :style="item.style" />
      <IconPolygon v-else-if="item.symbol === 'polygon'"
        class="ct-mapbox-legend__symbol ct-mapbox-legend__symbol--polygon" :style="item.style" />
      <span class="ct-mapbox-legend__label" v-text="item.label" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import IconPolygon from '@components/Icon/Polygon'
import {
  POINT_CIRCLE_COLOUR,
  POLYGON_DIAMOND_COLOR
} from '@root/constants'

const props = defineProps({
  translations: {
    type: Object,
    required: true
  },
  showPolygonDiamond: {
    type: Boolean,
    default: true
  }
})

const legendTranslation = props.translations.mapbox.legend

const legendItems = computed(() => [
  {
    key: 'polygon',
    symbol: props.showPolygonDiamond ? 'diamond' : 'polygon',
    style: {
      color: POLYGON_DIAMOND_COLOR,
      backgroundColor: props.showPolygonDiamond ? POLYGON_DIAMOND_COLOR : undefined
    },
    label: legendTranslation.polygon_area
  },
  {
    key: 'point',
    symbol: 'circle',
    style: { backgroundColor: POINT_CIRCLE_COLOUR },
    label: legendTranslation.point_data
  }
])
</script>

<style scoped lang="postcss">
.ct-mapbox-legend {
  @apply absolute bottom-3 right-[10px] z-10 flex max-w-[12.5rem] flex-col gap-2 rounded bg-white p-3 shadow-sm;

  &__title {
    @apply small-text-2 font-semibold text-theme-grey-medium;
  }

  &__hint {
    @apply small-text-2 text-theme-grey-medium;
  }

  &__item {
    @apply flex items-start gap-2;
  }

  &__symbol {
    @apply mt-0.5 h-3 w-3 shrink-0;

    &--circle {
      @apply rounded-full;
    }

    &--diamond {
      @apply mt-[0.3rem];
      transform: rotate(45deg);
    }

    &--polygon {
      @apply h-4 w-4;
    }
  }

  &__label {
    @apply small-text-2 text-theme-grey-medium;
  }
}
</style>
